import userHelper from 'utils/user'

function setAdminClientHelperForLoggedInUser({ state }) {
  let user = state.get('client.user')
  let helper = userHelper(user)

  state.set('client.helper.admin.user', {
    isAdmin: helper.isAdmin(),
    isBilles: helper.isBilles(),
    shared: user.currentClient.modules
      ? user.currentClient.modules.reduce((acc, module) => {
          if (module.shared) {
            acc = true
          }
          return acc
        }, false)
      : false
  })
}

export default setAdminClientHelperForLoggedInUser



// WEBPACK FOOTER //
// ./src/modules/user/actions/setAdminClientHelperForLoggedInUser.js